'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _recompose = require('recompose');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _offkey = require('offkey');

var _lodash = require('lodash');

var _bound = require('./utils/bound');

var _bound2 = _interopRequireDefault(_bound);

var _KeyHandler = require('./KeyHandler');

var _KeyHandler2 = _interopRequireDefault(_KeyHandler);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 *
 */
var NumberInput = (_temp = _class = function (_Component) {
	_inherits(NumberInput, _Component);

	/**
  *
  */


	/**
  *
  */
	function NumberInput(props) {
		_classCallCheck(this, NumberInput);

		var _this = _possibleConstructorReturn(this, (NumberInput.__proto__ || Object.getPrototypeOf(NumberInput)).call(this, props));

		(0, _lodash.bindAll)(_this, 'handleChange', 'handleBlur', 'handleMin', 'handleMax', 'handleIncrement', 'handleBigIncrement', 'handleDecrement', 'handleBigDecrement');

		_this.id = (0, _lodash.uniqueId)('rea11y-');
		_this.state = {
			value: props.value
		};
		return _this;
	}

	/**
  *
  */


	/**
  *
  */


	_createClass(NumberInput, [{
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(props) {
			this.setState({
				value: props.value
			});
		}

		/**
   *
   */

	}, {
		key: 'intVal',
		value: function intVal(value) {
			var number = parseInt(value, 10);
			return isNaN(number) ? this.props.min : number;
		}

		/**
   *
   */

	}, {
		key: 'emitChange',
		value: function emitChange(newValue) {
			var _props = this.props;
			var min = _props.min;
			var max = _props.max;
			var value = _props.value;
			var onChange = _props.onChange;

			var boundValue = (0, _bound2.default)(newValue, min, max);

			if (value !== boundValue) {
				onChange(boundValue);
			}
		}

		/**
   *
   */

	}, {
		key: 'handleChange',
		value: function handleChange(event) {
			var value = parseInt(event.target.value, 10);

			if (isNaN(value)) {
				this.setState({
					value: ''
				});
			} else {
				this.emitChange(value);
			}
		}

		/**
   *
   */

	}, {
		key: 'handleBlur',
		value: function handleBlur(event) {
			this.emitChange(this.intVal(event.target.value));
		}

		/**
   *
   */

	}, {
		key: 'handleMin',
		value: function handleMin() {
			this.emitChange(this.props.min);
		}

		/**
   *
   */

	}, {
		key: 'handleMax',
		value: function handleMax() {
			this.emitChange(this.props.max);
		}

		/**
   *
   */

	}, {
		key: 'handleIncrement',
		value: function handleIncrement() {
			this.emitChange(this.intVal(this.state.value) + this.props.step);
		}

		/**
   *
   */

	}, {
		key: 'handleBigIncrement',
		value: function handleBigIncrement() {
			this.emitChange(this.intVal(this.state.value) + this.props.bigStep);
		}

		/**
   *
   */

	}, {
		key: 'handleDecrement',
		value: function handleDecrement() {
			this.emitChange(this.intVal(this.state.value) - this.props.step);
		}

		/**
   *
   */

	}, {
		key: 'handleBigDecrement',
		value: function handleBigDecrement() {
			this.emitChange(this.intVal(this.state.value) - this.props.bigStep);
		}

		/**
   *
   */

	}, {
		key: 'renderControls',
		value: function renderControls() {
			try {
				var controls = _react.Children.only(this.props.children);

				return (0, _react.cloneElement)(controls, {
					onIncrement: this.handleIncrement,
					onDecrement: this.handleDecrement
				});
			} catch (e) {
				return undefined;
			}
		}

		/**
   *
   */

	}, {
		key: 'render',
		value: function render() {
			var _ref;

			var controls = this.renderControls();
			var className = (0, _classnames2.default)({
				'rea11y-NumberInput': true,
				'rea11y-NumberInput--withControls': !!controls
			});

			return _react2.default.createElement(
				'div',
				{ className: className },
				_react2.default.createElement(
					_KeyHandler2.default,
					{
						handlers: (_ref = {}, _defineProperty(_ref, _offkey.HOME, this.handleMin), _defineProperty(_ref, _offkey.END, this.handleMax), _defineProperty(_ref, _offkey.ARROW.UP, this.handleIncrement), _defineProperty(_ref, _offkey.PAGE_UP, this.handleBigIncrement), _defineProperty(_ref, _offkey.ARROW.DOWN, this.handleDecrement), _defineProperty(_ref, _offkey.PAGE_DOWN, this.handleBigDecrement), _ref)
					},
					_react2.default.createElement('input', {
						ref: 'input',
						id: this.id,
						className: 'rea11y-NumberInput-value',
						type: 'text',
						role: 'spinbutton',
						'aria-valuemin': this.props.min,
						'aria-valuemax': this.props.max,
						'aria-valuenow': this.state.value,
						value: this.state.value,
						onChange: this.handleChange,
						onBlur: this.handleBlur
					})
				),
				controls
			);
		}
	}]);

	return NumberInput;
}(_react.Component), _class.propTypes = {
	min: _react.PropTypes.number,
	max: _react.PropTypes.number,
	step: _react.PropTypes.number,
	bigStep: _react.PropTypes.number,
	value: _react.PropTypes.number,
	onChange: _react.PropTypes.func,
	children: _react.PropTypes.element
}, _class.defaultProps = {
	min: 0,
	max: 100,
	step: 1,
	bigStep: 10,
	value: 0,
	onChange: _lodash.noop
}, _temp);
exports.default = (0, _recompose.pure)(NumberInput);